export const scales = [
  {
    name: "gram",
    value: "g",
  },
  {
    name: "milli liter",
    value: "ml",
  },
  {
    name: "meter",
    value: "m",
  },
  {
    name: "unit",
    value: "u",
  },
];
